module.exports = __webpack_public_path__ + "static/media/payment-tick.f6df118c.svg";